import { render } from "./classifica-2021.html?vue&type=template&id=7a588ed3"
import script from "./classifica-2021.js?vue&type=script&lang=js"
export * from "./classifica-2021.js?vue&type=script&lang=js"

import "./classifica-2021.less?vue&type=style&index=0&lang=less"

import exportComponent from "/Users/vito.degioia/Documents/Projects/mb-fiori-2023/fiori-del-mulino/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__